import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ActionButton from '../action-button';
import Heading from '../heading';
import Paragraph from '../paragraph';

const IntegrationItem = ({
  imageSrc = null,
  imageAlt = null,
  title,
  description = null,
  isSelected = false,
  primaryButton = null,
  secondaryButton = null,
}) => (
  <div
    className={classNames('ws-ui-integration-item', {
      'ws-ui-integration-item--selected': isSelected,
    })}
  >
    {imageSrc && (
      <div className="ws-ui-integration-item__image-wrapper">
        <img alt={imageAlt} src={imageSrc} />
      </div>
    )}
    <div className="ws-ui-integration-item__content-wrapper">
      <div className="ws-ui-integration-item__content">
        {title && (
          <div className="ws-ui-integration-item__title">
            <Heading type="heading-6">{title}</Heading>
          </div>
        )}
        {description && (
          <div className="ws-ui-integration-item__description">
            <Paragraph size="small" appearance="medium-emphasis">
              {description}
            </Paragraph>
          </div>
        )}
      </div>
      <div className="ws-ui-integration-item__button-group">
        {primaryButton && primaryButton.onClick && (
          <ActionButton
            format={primaryButton.format}
            iconGlyph={primaryButton.iconGlyph || null}
            onClick={primaryButton.onClick}
            label={primaryButton.label}
            appearance={primaryButton.appearance}
          />
        )}
        {secondaryButton && secondaryButton.onClick && (
          <ActionButton
            format={secondaryButton.format}
            iconGlyph={secondaryButton.iconGlyph || null}
            onClick={secondaryButton.onClick}
            label={secondaryButton.label}
            appearance={secondaryButton.appearance}
          />
        )}
      </div>
    </div>
  </div>
);

IntegrationItem.propTypes = {
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  isSelected: PropTypes.bool,
  primaryButton: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
    iconGlyph: PropTypes.string,
    format: PropTypes.string,
    appearance: PropTypes.string,
  }),
  secondaryButton: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
    iconGlyph: PropTypes.string,
    format: PropTypes.string,
    appearance: PropTypes.string,
  }),
};

export default IntegrationItem;
